import React from "react";
import { AllocationMatrixBreakdownItem } from "services/BookingManagerApi/types/AllocationsResponse";
import { CarComponent, HomeComponent, MealComponent, SuitComponent } from "ui/Icons";

const getProductIcon = (type: string) => {
  switch (type) {
    case "Accommodation":
      return HomeComponent;
    case "Transfer":
      return CarComponent;
    case "Ground Service":
      return MealComponent;
    default:
      return SuitComponent;
  }
};

export const TooltipContent: React.FC<{ products: AllocationMatrixBreakdownItem[] }> = ({ products = [] }) => (
  <div className='max-h-[195px] rounded-1px font-pt-sans'>
    <div className='text-brown-prime text-13px mb-10px'>Guest Allocated To:</div>
    <div className='overflow-auto max-h-[158px] flex flex-col gap-10px'>
      {products.length > 0 ?
        products.map(product => {
          const Icon = getProductIcon(product.productType);
          const label =
            product.productType === "Accommodation"
              ? `${product.hotelName} ${product.name}`
              : product.name;

          return (
            <div key={product.uuid} className="flex items-center gap-5px">
              <Icon icon="gray-40" className="h-14px w-18px rounded-3px" />
              <div className="text-black text-13px leading-snug">{label}</div>
            </div>
          );
        }) :
        'None'
      }
    </div>
  </div>
)
